import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { userPaths } from 'routes/constants/userPaths';
import { setUnitId } from 'store/slices/authSlice';

import { Navigate } from 'react-router-dom';

import { getJwtUnitId } from 'utils/jwtUnitClaims';

import { hydrateEndUserProfile } from 'services/endUser/hydrateEndUserProfile';
import { resolveEndUserAuth } from 'services/endUser/resolveEndUserAuth';
import {
  applyPostAuthNavigationEffects,
  resolveEndUserJourneyRoute,
} from 'services/endUser/resolveEndUserJourneyRoute';

import { resolvePostLoginDestinationPath } from '@/services/auth/postLoginRedirectStorage';

type ResolveState = 'loading' | 'ready';

const DashboardResolver = () => {
  const dispatch = useDispatch();
  const [targetPath, setTargetPath] = useState<string>(userPaths.endUser);
  const [resolveState, setResolveState] = useState<ResolveState>('loading');

  useEffect(() => {
    const auth = resolveEndUserAuth({
      euId: window.localStorage.getItem('euId'),
      idToken: null,
    });

    if (!auth.euId || !auth.idToken) {
      setTargetPath(userPaths.endUser);
      setResolveState('ready');
      return;
    }

    const unitId = getJwtUnitId(auth.idToken);
    if (unitId) {
      dispatch(setUnitId(unitId));
    }

    void hydrateEndUserProfile(auth.euId, auth.idToken, dispatch)
      .then(result => {
        const destination = resolveEndUserJourneyRoute({
          state: result?.profileState,
          accountState: result?.accountState,
          hasExpenses: result?.hasExpenses === true,
        });
        const resolvedPath = resolvePostLoginDestinationPath(
          destination.path,
          destination.reason !== 'onboarding'
        );
        applyPostAuthNavigationEffects(resolvedPath, unitId);
        setTargetPath(resolvedPath);
      })
      .finally(() => {
        setResolveState('ready');
      });
  }, [dispatch]);

  if (resolveState === 'loading') {
    return null;
  }

  return <Navigate to={targetPath} replace />;
};

export default DashboardResolver;
